// extracted by mini-css-extract-plugin
module.exports = {"root":"Message_root__Nd-K8","hide":"Message_hide__3v_YU"};